import { ORDER_STATUS } from "../model/order";

const getOrderStatusCount = (orders) =>
  orders.reduce(
    (counts, order) => {
      if (
        order?.recycled ||
        order?.status === ORDER_STATUS.CANCELLED ||
        order?.statusDescription === "Cancelled"
      ) {
        counts.cancelledCount += 1;
      } else if (order?.status === ORDER_STATUS.DRAFT) {
        counts.draftCount += 1;
      } else if (order?.status === ORDER_STATUS.SUBMITTED) {
        counts.sentCount += 1;
      } else if (order?.status === ORDER_STATUS.CONFIRMED) {
        counts.confirmedCount += 1;
      }
      return counts;
    },
    { draftCount: 0, confirmedCount: 0, cancelledCount: 0, sentCount: 0 },
  );

export default getOrderStatusCount;
